module.exports = __webpack_public_path__ + "fonts/66efb6f541aacb67987b5238d4eb33af.svg";